/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIamUserRequest
 */
export interface GetIamUserRequest {
    /**
     * 
     * @type {string}
     * @memberof GetIamUserRequest
     */
    iamUserId: string;
}

export function GetIamUserRequestFromJSON(json: any): GetIamUserRequest {
    return GetIamUserRequestFromJSONTyped(json, false);
}

export function GetIamUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserId': json['iam_user_id'],
    };
}

export function GetIamUserRequestToJSON(value?: GetIamUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user_id': value.iamUserId,
    };
}


